import React, { createContext, useCallback, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as mixpanel from 'mixpanel-browser';

export const TrackerContext = createContext({});

const mixpanelId = process.env.MIXPANEL_PROJECT_TOKEN || '';

function TrackerProvider({ children }) {
  // Initialised during the first render, not in an effect: child effects run before the
  // provider's own, so anything a screen tracks on mount (the *_view events) was dropped.
  const [isReady] = useState(() => {
    mixpanel.init(mixpanelId);
    return true;
  });

  // Set user id
  const setUserId = useCallback((userId) => {
    mixpanel.identify(userId);
  }, []);

  // Event Name & Properties
  const eventTracker = useCallback(
    (name, props = {}) => {
      if (!isReady) {
        return;
      }
      const trackerResult = mixpanel.track(name, props);
      return trackerResult;
    },
    [isReady]
  );

  // Reset Tracker
  const resetTracker = useCallback(() => {
    const reset = mixpanel.reset();
    return reset;
  }, []);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const trackerContextValue = { isReady, setUserId, eventTracker, resetTracker };

  return <TrackerContext.Provider value={trackerContextValue}>{children}</TrackerContext.Provider>;
}

export default TrackerProvider;
